// ** Reducers Imports
import publicStore from "../routes/app/public/store";
import policyWalletStore from "../routes/app/auth/policy_wallet/store";
import commonStore from "../common/store";
import dashboardStore from "../routes/app/auth/dashboard/store";
import claimStore from "../routes/app/auth/claim/store";
import MyProfileStore from "../routes/app/auth/my_profile/store";
import appointmentsStore from "../routes/app/auth/appointments/store";
import enquiryAddStore from "../routes/app/auth/enquiry/store";
import reviewsStore from "../routes/app/auth/reviews/store";
import NotificationStore from "../routes/app/auth/notifications/store";
import policyStore from "../routes/app/auth/policies/store";
import listStore from "../routes/app/auth/list/store";
import AddNewVehicleStore from "../routes/app/auth/new_vehicles/store";
import quoteListStore from "../routes/app/auth/quotes_list/store";
import otherQuoteListStore from "../routes/app/auth/other_quote_list/store";
import employerStore from "../routes/app/auth/employer/store";
import formStore from "../routes/app/auth/forms/store";
import changePasswordStore from "../routes/app/auth/changePassword/store";

const rootReducer = {
  publicStore,
  policyWalletStore,
  commonStore,
  dashboardStore,
  claimStore,
  MyProfileStore,
  appointmentsStore,
  enquiryAddStore,
  reviewsStore,
  NotificationStore,
  policyStore,
  listStore,
  AddNewVehicleStore,
  AddNewVehicleStore,
  quoteListStore,
  otherQuoteListStore,
  employerStore,
  formStore,
  changePasswordStore
};

export default rootReducer;
